module.exports = __webpack_public_path__ + "media/images/emoticons/five-be792d0853cd191077f71fc4ceb9edbe.gif";